import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedProjectleadersReducer(state = initialState.selectedProjectleaders, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_PROJECTLEADERS_SUCCESS:
      return action.selectedProjectleaders;
    default:
      return state;
  }
}
